import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import {ProjectConfig} from 'Global';
import { ApiRequest } from "GlobalFunctions";

export default function CategoriesEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, category_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    category_id: category_id ? category_id : "null",
    category_name: "",
    category_code: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (category_id) {
      axios.get(`${ProjectConfig.api_url}/categories/details`, {
        params: { category_id },
      })
      .then((response) => {
        setFormValues(response.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
    } else {
      setFormValues(defaultValues);
    }
  }, [category_id]);

  const handleInputChange = (e: { target: { name: any; value: any }; }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {  
    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));
    
    await ApiRequest({
      url: "/categories/addedit",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar('Categoría guardada con éxito', { variant: 'success' });
          setOpenEditor(false);
          loadList();
          
        }else{
          enqueueSnackbar(response.message, { variant: 'error' });
        }
        setLoading(false);
      },
    }); 
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: '502px' }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Categoría</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="category_name"
              name="category_name"
              label="Nombre de la Categoría"
              type="text"
              required
              fullWidth
              value={formValues.category_name}
              onChange={handleInputChange}
            />

            <TextField
              id="category_code"
              name="category_code"
              label="Código de la Categoría"
              type="text"
              required
              fullWidth
              value={formValues.category_code}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained">Guardar</Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
